import moment from 'moment';
import React from 'react';
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row
} from 'react-bootstrap';
import Datetime from 'react-datetime';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';
import { formatCrewName } from '../../../utils';
import CrewName from '../CrewName';
import EditCrew from '../EditCrew';
import JobStatusDropdown from '../JobStatusDropdown';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Timekeeper from 'react-timekeeper';

const TimeContainer = styled.div`
  position: absolute;
  display: block;
  z-index: 2;
`;

const TimeDisplayContainer = styled.div`
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  border-radius: 2px;
  -webkit-box-shadow: 2px 2px 15px 0 rgba(0, 0, 0, .15);
  height: 50px;
  line-height: 50px;
  width: 260px;
`;

const TimeResetContainer = styled.div`
  text-align: center;
  font-weight: bold;
  color: #EE0303;
  font-size: 9px;
  height: 20px;
  line-height: 20px;
  width: 260px;
  cursor: pointer;
`;

const defaultCrew = {
  equipment: null,
  resources: []
};

const transformCrewToOption = (crew) => ({
  crew,
  disabled: crew.disabled,
  label: formatCrewName(crew),
  value: crew.id
});

const unassignedCrewOption = {
  crew: null,
  label: 'Unassigned',
  value: ''
};

const getCrewOptions = (jobCrews, standardCrews) => [
  unassignedCrewOption,
  { label: 'Job Crews', options: jobCrews.map(transformCrewToOption) },
  { label: 'Standard Crews', options: standardCrews.map(transformCrewToOption) }
];

class EditEvent extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        displayTimepicker: false,
        startTime: props.event.startTime ? moment(props.event.startTime, 'HH:mm:ss').format('hh:mma') : '',
        endTime: props.event.endTime ? moment(props.event.endTime, 'HH:mm:ss').format('hh:mma') : ''
    };

    this._startTimeChecker = this.startTimeChecker.bind(this);
    this._endTimeChecker = this.endTimeChecker.bind(this);
    this._resetTime = this.resetTime.bind(this);
  }  

  static get propTypes() {
    return {
      event: PropTypes.object.isRequired
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.event !== this.props.event) {
      this.setState({
        startTime: nextProps.event.startTime ? moment(nextProps.event.startTime, 'HH:mm:ss').format('hh:mma') : '',
        endTime : nextProps.event.endTime ? moment(nextProps.event.endTime, 'HH:mm:ss').format('hh:mma') : ''
      });
    }
  }

  toggleTimekeeper(val){
    this.setState({displayTimepicker: val})
  }

  resetTime(w){
    const {onChange, event } = this.props;
    if(w === 'start'){
      onChange({ event, startTime: null });
      this.setState({startTime: '' });
    }
    else{
      onChange({ event, endTime: null });
      this.setState({endTime: '' });      
    }
  }

  startTimeChecker(e){
    const { onChange, event } = this.props;

    var newStartTime = moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma');

    if(newStartTime.isAfter(moment(this.state.endTime, 'hh:mma'))){
      onChange({ event, endTime: moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma').format('HH:mm:ss') });
      this.setState({endTime: newStartTime.format('hh:mma')});
    }
    onChange({ event, startTime: moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma').format('HH:mm:ss') });
    this.setState({startTime: newStartTime.format('hh:mma')});
  }

  endTimeChecker(e){
    const { onChange, event } = this.props;

    var newEndTime = moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma');

    if(newEndTime.isBefore(moment(this.state.startTime, 'hh:mma'))){
      onChange({ event, startTime: moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma').format('HH:mm:ss') });
      this.setState({endTime: newEndTime.format('hh:mma')});
    }
    onChange({ event, endTime: moment(e.hour + ':' + e.minute + e.meridiem, 'h:mma').format('HH:mm:ss') });
    this.setState({endTime: newEndTime.format('hh:mma')});
  }

  render() {

    const {
      equipment,
      event,
      isEditCrewEnabled,
      jobCrews,
      jobStatuses,
      onChange,
      onToggleEditCrew,
      resources,
      standardCrews
    } = this.props 
    
    return (
      <div>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Start Date/Time</ControlLabel>
              <Datetime
                input={false}
                isValidDate={(value) =>
                  event.endDate ? !value.isAfter(event.endDate) : true
                }
                timeFormat={false}
                onChange={(e) => onChange({ startDate: e.format('YYYY-MM-DD') })}
                value={event.startDate ? moment(event.startDate) : ''}
              />
              {this.state.displayTimepicker ?
              <TimeContainer>
                <Timekeeper
                  time={this.state.startTime}
                  switchToMinuteOnHourSelect={true}
                  onDoneClick={() => {
                    this.toggleTimekeeper(false)
                  }}
                  config={{
                    TIMEPICKER_BACKGROUND: 'white',
                    DONE_BUTTON_COLOR: '#64c9f1',
                    DONE_BUTTON_BORDER_COLOR: '#ededed'
                  }}    
                  onChange={(e) => this._startTimeChecker(e)}
                />
              </TimeContainer>
              : false}
              <TimeDisplayContainer onClick={() => this.toggleTimekeeper(true)}>
                <FontAwesome name="clock-o"/> {event.startTime ? moment(event.startTime, 'HH:mm:ss').format('hh:mma') : ''}
              </TimeDisplayContainer>
              <TimeResetContainer onClick={() => this._resetTime('start')}>
                <FontAwesome name="close"/> reset
              </TimeResetContainer>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>End Date/Time</ControlLabel>
              <Datetime
                input={false}
                isValidDate={(value) =>
                  event.startDate ? !value.isBefore(event.startDate) : true
                }
                onChange={(e) => onChange({ endDate: e.format('YYYY-MM-DD') })}
                timeFormat={false}
                value={event.endDate ? moment(event.endDate) :  moment(Date())}
              />
              {this.state.displayTimepicker ?
              <TimeContainer>
                <Timekeeper
                  time={this.state.endTime}
                  switchToMinuteOnHourSelect={true}
                  onDoneClick={() => {
                    this.toggleTimekeeper(false)
                  }}
                  config={{
                    TIMEPICKER_BACKGROUND: 'white',
                    DONE_BUTTON_COLOR: '#64c9f1',
                    DONE_BUTTON_BORDER_COLOR: '#ededed'
                  }}                  
                  onChange={(e) => this._endTimeChecker(e)}
                />
              </TimeContainer> 
              : false}
              <TimeDisplayContainer onClick={() => this.toggleTimekeeper(true)}>
                <FontAwesome name="clock-o"/> {event.endTime ? moment(event.endTime, 'HH:mm:ss').format('hh:mma') : ''}
              </TimeDisplayContainer>
              <TimeResetContainer onClick={() => this._resetTime('end')}>
                <FontAwesome name="close"/> reset
              </TimeResetContainer>   
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>Description</ControlLabel>
              <FormControl
                componentClass="textarea"
                onChange={(e) => onChange({ description: e.target.value })}
                rows={3}
                value={event.description || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} mdOffset={3}>
            <FormGroup>
              <ControlLabel>Job Status</ControlLabel>
              <JobStatusDropdown
                clearable={false}
                jobStatuses={jobStatuses}
                onChange={(js) => onChange({ jobStatus: js || null })}
                value={event.jobStatus}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>Job Priority Notes</ControlLabel>
              <FormControl
                componentClass="textarea"
                onChange={(e) => onChange({ jobPriorityNotes: e.target.value })}
                rows={3}
                value={event.jobPriorityNotes || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <hr />
        {isEditCrewEnabled ? (
          <EditCrew
            crew={event.crew || defaultCrew}
            onChange={(crew) => onChange({ crew })}
            equipment={equipment}
            resources={resources}
            showpercentage={true}
          />
        ) : (
          <FormGroup>
            <ControlLabel>Crew</ControlLabel>
            <InputGroup>
              <InputGroup.Button>
                <Button onClick={() => onToggleEditCrew()}>
                  <FontAwesome name="pencil" />
                </Button>
              </InputGroup.Button>
              <Select
                clearable={false}
                onChange={({ crew }) => onChange({ crew: crew || null })}
                optionRenderer={(o) =>
                  o.crew ? <CrewName crew={o.crew} /> : o.label
                }
                options={getCrewOptions(jobCrews, standardCrews)}
                placeholder="Unassigned"
                value={event.crew ? event.crew.id : ''}
                valueRenderer={(o) => <CrewName crew={o.crew} />}
              />
            </InputGroup>
          </FormGroup>
        )}
      </div>
    );
  }

};
export default EditEvent;
